var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UISelect',{attrs:{"multiple":"","value":_vm.formValues.rates,"error":_vm.errors.rates,"options":_vm.optionsData,"placeholder":_vm.$t('bi.field.placeholder.choose')},on:{"change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }